/**
 * Zwei Fälle, die gern verwechselt werden (Vertrag §5).
 */

import { hatAktivenFilter, type AufgabenFilter } from "./filter.js";

export type LeerArt = "nichts" | "filter_leer";

export function leerArt(optionen: {
  gesamtOhneFilter: number;
  gefiltert: number;
  hatAktivenFilter: boolean;
}): LeerArt | null {
  if (optionen.gefiltert > 0) return null;
  if (optionen.gesamtOhneFilter === 0) return "nichts";
  if (optionen.hatAktivenFilter) return "filter_leer";
  return "nichts";
}

export function leerText(
  art: LeerArt,
  bereich: "projekte" | "aufgaben" | "meilensteine" | "projekt_aufgaben" | "start",
): { titel: string; hinweis: string; aktion?: string } {
  if (art === "filter_leer") {
    switch (bereich) {
      case "projekte":
        return {
          titel: "Kein Projekt passt zur Suche.",
          hinweis: "Filter löschen, um alle Projekte zu sehen.",
          aktion: "Filter löschen",
        };
      default:
        return {
          titel: "Kein Treffer. Filter lockern.",
          hinweis: "Passe die Filter an oder setze sie zurück.",
          aktion: "Filter löschen",
        };
    }
  }

  switch (bereich) {
    case "projekte":
      return {
        titel: "Noch kein Projekt.",
        hinweis: "Lege eins an — dann können Aufgaben folgen.",
        aktion: "Projekt anlegen",
      };
    case "aufgaben":
      return {
        titel: "Keine Aufgaben in deinen Projekten.",
        hinweis: "Lege die erste Aufgabe an, damit die Arbeit sichtbar wird.",
        aktion: "Aufgabe anlegen",
      };
    case "projekt_aufgaben":
      return {
        titel: "Dieses Projekt hat noch keine Aufgaben.",
        hinweis: "Lege die erste Aufgabe in diesem Projekt an.",
        aktion: "Aufgabe anlegen",
      };
    case "meilensteine":
      return {
        titel: "Keine Meilensteine.",
        hinweis: "Meilensteine bündeln Aufgaben und Termine.",
        aktion: "Meilenstein anlegen",
      };
    case "start":
      return {
        titel: "Willkommen.",
        hinweis: "Lege das erste Projekt an, um zu starten.",
        aktion: "Projekt anlegen",
      };
  }
}

export function filterIstAktiv(filter: AufgabenFilter): boolean {
  return hatAktivenFilter(filter);
}
